var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.56 10.09.85-2.15H3.07a1.08 1.08 0 0 0 0 2.15zM20.93 7.94h-1.08l.92 2.15h.16a1.08 1.08 0 0 0 0-2.15M2.87 17.87v1.07a1.68 1.68 0 1 0 3.36 0v-1.07zM18.17 18.94a1.68 1.68 0 1 0 3.36 0v-1.07h-3.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.22 11.13-2.44-5.66a3.45 3.45 0 0 0-3.17-2.09h-7a3.44 3.44 0 0 0-3.25 2.18l-2.23 5.61a3.5 3.5 0 0 0-.24 1.28v5.42h18.62V12.5a3.4 3.4 0 0 0-.29-1.37M5.8 8.92l.94-2.86a.63.63 0 0 1 .6-.44h9.5a.65.65 0 0 1 .61.44l.94 2.86a.64.64 0 0 1-.61.84H6.4a.64.64 0 0 1-.6-.84m-.2 5.55a1.05 1.05 0 1 1 1.05-1.05 1 1 0 0 1-1.05 1.05m13 0a1.05 1.05 0 1 1 1.05-1.05 1 1 0 0 1-1.03 1.05z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.84 16.229h-7a.75.75 0 1 1 0-1.5h7a.75.75 0 1 1 0 1.5"
  })));
};
export default SvgCar;